<template>
  <div>
    <!-- Table Container Card -->
    <b-card
      no-body
      class="mb-0"
    >
      <div class="m-2">
        <!-- Table Top -->
        <b-row>
          <!-- Search -->
          <b-col
            cols="12"
            md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <label
                v-b-tooltip.hover.top="titleFormatoImportar"
                for="file"
                class="btn btn-outline-success"
                style="margin-right:5px;margin-top:4px"
              >
                <span
                  v-show="isBusyImport===true"
                >
                  Cargando...
                </span>
                <span
                  v-show="isBusyImport===false"
                >
                  Importar Centros Poblados
                </span>
              </label>
              <input
                v-show="false"
                id="file"
                type="file"
                @change="onChange"
              >
            </div>
          </b-col>
        </b-row>

      </div>
    </b-card>
  </div>
</template>

<script>
import Vue from 'vue'
import {
  BCard, BRow, BCol, VBTooltip,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { _ } from 'vue-underscore'
import XLSX from 'xlsx'
import store from '@/store'
import { showToast } from '@/helpers'

export default {
  components: {
    BCard,
    BRow,
    BCol,
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  data: () => ({
    isBusyImport: false,
    titleFormatoImportar: 'Importar centros poblados de ubideos',
    dataImport: [],
  }),
  methods: {
    saveData(data) {
      if (_.isUndefined(data[0])) {
        this.showToast('Ha ocurrido un error', 'El formato seleccionado es invalido.', 'danger')
        this.isBusyImport = false
      } else {
        store
          .dispatch('gsencuesta/UBIGEO_CREATE_ALL_CENTRO_POBLADO', data)
          .then(response => {
            this.isBusyImport = false
            // const data = (response.length <= 0) ? 'Datos guardados correctamente' : `los siguientes documentos ya existe: ${}`
            let documents = ''
            let mensaje = ''
            if (response.length > 0) {
              response.forEach(dat => {
                documents = `${documents} ${dat.dni} - `
              })
              mensaje = `Los siguientes documentos ya existen: ${documents}`
            } else {
              mensaje = 'Datos guardados correctamente'
            }
            this.showToast('Operación Exitosa', mensaje, 'success')
            return response
          })
          .catch(error => {
            this.isBusyImport = false
            this.showToast('Ha ocurrido un error', error.response.data.errorMessage, 'danger')
            // this.listarRegistros()
          })
      }
    },
    onChange(event) {
      Vue.swal({
        title: 'Está seguro?',
        text: 'Centtros poblados serán insertados',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Guardar',
        cancelButtonText: 'Cancelar',
        customClass: {
          confirmButton: 'btn btn-danger',
          cancelButton: 'btn btn-primary ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.saveUbigeo(event)
        }
      })
    },
    viewSavePoints(event) {
      this.isBusyImport = true
      const file = event.target.files ? event.target.files[0] : null
      let stateTabData = false
      if (file) {
        const fileReader = new FileReader()
        fileReader.onload = e => {
          let binary = ''
          const bytes = new Uint8Array(e.target.result)
          const length = bytes.byteLength
          for (let i = 0; i < length; i += 1) {
            binary += String.fromCharCode(bytes[i])
          }
          const workbook = XLSX.read(binary, { type: 'binary', cellDates: true, dateNF: 'dd/mm/yyyy;@' })
          const sheetNameList = workbook.SheetNames
          this.dataImport = []
          sheetNameList.forEach(y => {
            const roa = XLSX.utils.sheet_to_json(workbook.Sheets[y])
            // const arrayDetail = []
            // let index = 0
            if (roa.length > 0) {
              if (y === 'DATA') {
                stateTabData = true
                roa.forEach(dat => {
                  this.dataImport.push({
                    codigoDistrito: dat.CODIGO_DISTRITO,
                    codigo: dat.CODIGO,
                    descripcion: dat.DESCRIPCION,
                  })
                })
              }
            }
          })
          document.getElementById('file').value = ''
          if (!stateTabData) {
            this.isBusyImport = false
            this.showToast('Warning', 'En el formato excel, el tap de exportación debe ser de nombre DATA.', 'warning')
          } else {
            this.saveData(this.dataImport)
          }
          // saveData(dataImport.value)
        }
        fileReader.readAsArrayBuffer(file)
      }
    },
    showToast,
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
